import { S_Wrapper } from './style';
const NotFound = () => {
  return (
    <S_Wrapper>
      <h1>404 PAGE NOT FOUND</h1>
    </S_Wrapper>
  );
};

export default NotFound;
